import './styles.scss'

import { useTranslation } from 'react-i18next'

import Footer from '@/components/Layout/Footer'
import Header from '@/components/PublicHeader/Header'
import ScrollToTop from '@/components/ScrollToTop'
import useAdobeAnalysis from '@/hooks/useAdobeAnalysis'
import useDocumentTitle from '@/hooks/useDocumentTitle'
import { PAGE_TYPES } from '@/libs/constants/adobeAnalytics'
import { parseHtml } from '@/libs/utils/common'

const GeneralTermsAndConditions = () => {
  useDocumentTitle('pageTitle.generalTerms')
  const { t, i18n } = useTranslation()

  useAdobeAnalysis(null, {
    pageName: 'general terms and conditions',
    pageId: '35',
    pageType: PAGE_TYPES.POLICY,
  })

  const renderSections = () => {
    const sections = []
    let index = 1

    while (i18n.exists(`generalTermsAndConditions.section${index}`)) {
      sections.push(
        <div key={`section-${index}`} className="general-terms__section">
          <section>
            {parseHtml(t(`generalTermsAndConditions.section${index}`))}
          </section>
        </div>,
      )
      index += 1
    }
    return sections
  }

  return (
    <>
      <Header />
      <ScrollToTop />
      <div className="general-terms__wrapper">
        <div className="general-terms__wrapper-width">{renderSections()}</div>
      </div>
      <Footer />
    </>
  )
}

export default GeneralTermsAndConditions
